export default __webpack_public_path__ + "static/Montserrat-Regular-ceb11275ab638627a64310000e9446ec.ttf";